import React, { useState, useEffect } from "react";
import {
	Alert,
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
	Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PreviewPdfViewer from "./PreviewPdfViewer";

const PreviewDialog = ({
	open,
	onClose,
	onPreview,
	isPreviewing,
	previewResult,
	error,
	defaultPayload = {},
	previewDescription = "Sample data is sent to the API. Resolved variables are printed on the PDF at your saved positions.",
}) => {
	const [form, setForm] = useState(defaultPayload);

	useEffect(() => {
		if (open) setForm(defaultPayload);
	}, [open, defaultPayload]);

	const handlePreview = () => {
		onPreview(form);
	};

	const previewUrl = previewResult?.preview_document_url;
	const variables = previewResult?.variables;
	const formKeys = Object.keys(defaultPayload);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>Preview filled agreement</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					{previewDescription}
				</Typography>
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<Grid container spacing={2}>
					{formKeys.map((key) => (
						<Grid item xs={12} sm={6} key={key}>
							<TextField
								fullWidth
								size="small"
								label={key.replace(/_/g, " ")}
								value={form[key] ?? ""}
								onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
							/>
						</Grid>
					))}
				</Grid>

				{variables && (
					<Box mt={3}>
						<Typography variant="subtitle2" gutterBottom>
							Resolved variables
						</Typography>
						<Box
							component="pre"
							sx={{
								fontSize: "0.75rem",
								bgcolor: "grey.100",
								p: 1.5,
								borderRadius: 1,
								overflow: "auto",
								maxHeight: 160,
							}}
						>
							{JSON.stringify(variables, null, 2)}
						</Box>
					</Box>
				)}

				{previewUrl && (
					<Box mt={2}>
						<Button
							variant="outlined"
							startIcon={<OpenInNewIcon />}
							href={previewUrl}
							target="_blank"
							rel="noopener noreferrer"
							sx={{ mb: 1 }}
						>
							Open preview in new tab
						</Button>
						<PreviewPdfViewer url={previewUrl} />
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
				<Button variant="contained" onClick={handlePreview} disabled={isPreviewing}>
					{isPreviewing ? "Generating…" : "Generate preview"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PreviewDialog;
